module.exports = __webpack_public_path__ + "static/media/protegosafe_logo_white.8bc1d4b5.svg";